import Filter from "./Filter";

const Filters = ({ filtersList, setFilter }) => {
	const renderFilters = () => {
		if (!filtersList.length > 0) return null;

		return filtersList.map((filter, index) => (
			<Filter filter={filter} index={index} />
		));
	};

	return (
		<div className="index-page__filters">
			<form action="sumbit" onChange={(event) => setFilter(event.target.value)}>
				<div className="filter__wrap">
					<input name="news-index-filter" id="all" type="radio" value={""} />
					<label className="filter" htmlFor="all" tabIndex="0">
						All
					</label>
				</div>
				{renderFilters()}
			</form>
		</div>
	);
};

export default Filters;
